enum EventLogType {
  System = 'System',
  Request = 'Request',
}

export default EventLogType;

export const EventLogTypeLabel = {
  System: 'System-initiated events',
  Request: 'User-initiated events',
};

export const getEventLogTypeAsList = (): CommonList[] => {
  return Object.values(EventLogType).map((value) => ({
    id: value,
    label: EventLogTypeLabel[value],
    groupBy: 'Author type',
  }));
};
